import { useEffect, useState } from 'react';
import { loadMdiIconPaths } from '../utils/mdi-icons';

/**
 * Loads the MDI path data once and re-renders when it arrives.
 *
 * Returns whether it is ready rather than the module itself: components read individual
 * paths through `getMdiIconPath`, and passing the whole 7,000-entry object down through
 * props would make every icon re-render on any change to it.
 */
export const useMdiIcons = (enabled = true): boolean => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!enabled) return undefined;

    let active = true;
    loadMdiIconPaths()
      .then(() => {
        if (active) setLoaded(true);
      })
      .catch(() => {
        // An icon that cannot be resolved renders as a placeholder, which is a far better
        // outcome than failing the whole floorplan over its icon set.
        if (active) setLoaded(true);
      });

    return () => {
      active = false;
    };
  }, [enabled]);

  return loaded;
};

export default useMdiIcons;
